import { makeStyles } from "@material-ui/core/styles"
import React from "react"
import PropTypes from "prop-types"
import Link from "../Link"
import Typography from "../LandingComponents/Typography"

import Button from "@material-ui/core/Button"
import Card from "@material-ui/core/Card"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import CardMedia from "@material-ui/core/CardMedia"
import Grid from "@material-ui/core/Grid"

import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt"
import TheatersIcon from "@material-ui/icons/Theaters"

const useStyles = makeStyles((theme) => ({
  button: {
    color: "#0bd1bc",
    flex: 1,
    paddingBottom: 6,
    paddingLeft: 12,
    paddingRight: 10,
    paddingTop: 7,
    textTransform: "uppercase",
    width: "100%",
  },
  buttonContained: {
    color: "#fff",
    backgroundColor: "#0bd1bc",
    flex: 1,
    paddingBottom: 6,
    paddingLeft: 12,
    paddingRight: 10,
    paddingTop: 7,
    textTransform: "uppercase",
    width: "100%",
    "&:hover": {
      backgroundColor: "#25c0af",
    },
  },
  buttonOulined: {
    color: "#0bd1bc",
    backgroundColor: "#fff",
    border: "1px solid #d1d9e0",
    flex: 1,
    paddingBottom: 6,
    paddingLeft: 12,
    paddingRight: 10,
    paddingTop: 7,
    textTransform: "uppercase",
    width: "100%",
    "&:hover": {
      backgroundColor: "#f6f8fa",
    },
  },
  card: {
    border: "1px solid rgba(0, 0, 0, 0.08)",
    borderRadius: 8,
    boxShadow: "0px 4px 12px rgba(184, 184, 184, 0.25)",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    paddingBottom: 1,
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 12,
    width: "100%",
  },
  cardActions: {
    alignItems: "start",
    flexDirection: "row",
    display: "flex",
    gap: 3,
    justifyContent: "start",
    padding: 12,
    width: "100%",
    [theme.breakpoints.only("xs")]: {
      flexDirection: "column",
      gap: 9,
    },
  },
  cardLink: {
    textDecoration: "none",
    width: "fit-content",
    [theme.breakpoints.only("xs")]: {
      marginLeft: `0px !important`,
      width: "100%",
    },
  },
  /* Override the CardMedia 
    Styles applied to the root element. */
  root: {
    display: "block",
    backgroundSize: "80%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  cardContent: {
    flexGrow: 1,
    paddingTop: 8,
  },
}))

const DecideLink = ({ classes, proj, children }) => {
  return proj.external ? (
    <a
      href={proj.link}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.cardLink}
    >
      {children}
    </a>
  ) : (
    <Link underline="none" to={proj.link}>
      {children}
    </Link>
  )
}

const ProjectGrid = ({ allProjPics, imgHeight, mini, proj }) => {
  const classes = useStyles()

  const findMatchingProfile = (pic_filename, allPicFiles = allProjPics) => {
    const matchedNode = allPicFiles.find(
      ({ node }) => node.childImageSharp.fixed.originalName === pic_filename
    )

    return matchedNode.node.childImageSharp.fixed.src
  }

  return (
    <Grid item key={proj.title} xs={12} sm={6} md={4}>
      <Card className={classes.card} elevation={0}>
        <CardMedia
          classes={{
            root: classes.root,
          }}
          className={classes.cardMedia}
          image={findMatchingProfile(proj.pic_filename)}
          title={proj.title}
          style={{ height: imgHeight }}
        />
        <CardContent className={classes.cardContent}>
          <Typography gutterBottom variant="" component="h3">
            {proj.title}
          </Typography>

          {!mini && (
            <Typography
              component="span"
              variant="body2"
              className={classes.inline}
              color="textPrimary"
            >
              {proj.timeline || " "}
            </Typography>
          )}

          <Typography variant="body2" color="textSecondary" component="p">
            {mini ? proj.note : proj.long_note}
          </Typography>
        </CardContent>

        <CardActions className={classes.cardActions}>
          <DecideLink classes={classes} proj={proj}>
            <Button className={classes.buttonContained} size="small">
              Learn More
              <ArrowRightAltIcon />
            </Button>
          </DecideLink>

          {proj.video_link && (
            <a
              href={proj.video_link}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.cardLink}
            >
              <Button className={classes.buttonOulined} size="small">
                <TheatersIcon fontSize="small" />
                Watch Video
              </Button>
            </a>
          )}
        </CardActions>
      </Card>
    </Grid>
  )
}

ProjectGrid.propTypes = {
  projectList: PropTypes.array.isRequired,
  allProjPics: PropTypes.array.isRequired,
}

export default ProjectGrid
